import {forwardRef, Ref} from 'react'
import {InputNumber as AntdInputNumber, InputNumberProps} from 'antd'

export default forwardRef(function InputPercent(
  props: InputNumberProps,
  ref: Ref<HTMLInputElement>
) {
  const handleFormat = (value: any) => `${value}%`

  const handleParse = (value: any) => value!.replace('%', '')

  return (
    <AntdInputNumber
      {...props}
      ref={ref}
      min={0}
      max={100}
      formatter={handleFormat}
      parser={handleParse}
    />
  )
})
